
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termos",
      function () {
        return require("private-next-pages/termos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termos"])
      });
    }
  